// @ts-nocheck

import React from 'react';
import styled, { css } from 'styled-components';

import { type BoomStepId } from '../../types/steps';
import BoomStepDetailsContainer from '../BoomStepDetails/BoomStepDetailsContainer';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  height: 2.2em;

  ${({ $isAlginItemRight }) =>
    $isAlginItemRight
      ? css`
          justify-content: space-between;
        `
      : null}
`;

const Title = styled.div`
  font-size: 1.6em;
  color: ${({ $titleColor }) => $titleColor};
  text-shadow: 2px 2px 0 #000;
  font-family: 'ChangaOne', sans-serif;
`;

const StyledBoomStepDetailsContainer = styled(BoomStepDetailsContainer)`
  margin-left: 0.6em;
`;

type PropsType = {
  className?: string;
  stepId: BoomStepId;
  titleLabel: string;
  titleColor: string;
  isAlginItemRight?: boolean;
};

const BoomStepDetailsInfo = ({ className = '', stepId, titleLabel, titleColor, isAlginItemRight }: PropsType) => {
  return (
    <Wrapper className={className} $isAlginItemRight={isAlginItemRight}>
      <Title $titleColor={titleColor}>{titleLabel}</Title>
      <StyledBoomStepDetailsContainer stepId={stepId} />
    </Wrapper>
  );
};

export default BoomStepDetailsInfo;
